import { Box, Chip } from "@mui/material";
import { useTranslation } from "../../i18n/LanguageContext";
import { C } from "../../theme/dashboardCardTokens";

// Values match `progressStatus` exactly as documented in the backend's
// pagination & status filtering section — same step_key vocabulary as the
// timeline, plus "cancelled".
const FILTER_KEYS = [
  "unprocessed",
  "dispatched",
  "received_by_customer",
  "returned_to_lab",
  "processing",
  "analysis_completed",
  "completed",
  "cancelled",
];

function chipSx(active) {
  return {
    fontSize: "0.75rem",
    fontWeight: 600,
    bgcolor: active ? C.primary : C.gray7,
    color: active ? "#fff" : C.textSecondary,
  };
}

// Status-filter chip row shared by the patient/therapist order-list pages.
// Labels come from the i18n dictionary, not hardcoded, per the rule that
// status text is always looked up by step_key.
function StatusFilterChips({ value, onChange }) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        flexWrap: "nowrap",
        overflowX: "auto",
        pb: "4px",
        mb: "16px",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      <Chip
        label={t("portal.statusFilterChips.all")}
        clickable
        onClick={() => onChange("all")}
        sx={{ ...chipSx(value === "all"), flexShrink: 0 }}
      />
      {FILTER_KEYS.map((key) => (
        <Chip
          key={key}
          label={t(`portal.statusTimeline.steps.${key}.label`)}
          clickable
          onClick={() => onChange(key)}
          sx={{ ...chipSx(value === key), flexShrink: 0 }}
        />
      ))}
    </Box>
  );
}

export default StatusFilterChips;
